<template>
    <div class="flex flex-col h-screen-index">
        <!-- 头部导航 -->
        <div class="flex items-center justify-between p-4">
            <div class="flex items-center space-x-4">
                <div class="tabs tabs-boxed">
                    <a :class="{ 'tab': true, 'tab-active': activeTab === 'tagSource' }" @click="activeTab = 'tagSource'">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                        </svg>
                        <div class="hidden md:block">
                            {{ $tt('标签源插件') }}
                        </div>
                    </a>
                    <!-- <a :class="{ 'tab': true, 'tab-active': activeTab === 'action' }" @click="activeTab = 'action'">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <div class="hidden md:block">
                            操作台插件
                        </div>
                    </a> -->
                </div>
            </div>
            <div class="flex items-center space-x-2">
                <button class="btn btn-primary btn-sm" @click="refreshPlugins">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                    {{ $tt('刷新') }}
                </button>
                <button class="btn btn-outline btn-sm" @click="showUploadDrawer = true">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                    {{ $tt('添加插件') }}
                </button>
            </div>
        </div>

        <!-- 主要内容区域 -->
        <div class="flex flex-1 overflow-hidden">
            <!-- 左侧内容 -->
            <div class="flex-1 flex flex-col">
                <!-- 标签源插件列表 -->
                <div v-show="activeTab === 'tagSource'" class="p-4 overflow-y-auto flex-1">
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                        <div v-for="(plugin, index) in tagSourceScripts" :key="plugin.id" class="card bg-base-100 shadow-xl hover:shadow-2xl transition-shadow">
                            <div class="card-body p-4">
                                <div class="flex items-start justify-between">
                                    <div class="flex-1">
                                        <h3 class="card-title text-lg">{{ plugin.display_name }}</h3>
                                        <div class="flex items-center space-x-2 mt-1">
                                            <div class="badge badge-primary badge-sm">v{{ plugin.version || 'N/A' }}</div>
                                            <div :class="['badge', 'badge-sm','text-white', getPluginStatusClass(plugin)]">
                                                {{ getPluginStatusText(plugin) }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="dropdown dropdown-end">
                                        <label tabindex="0" class="btn btn-ghost btn-sm btn-circle">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01" />
                                            </svg>
                                        </label>
                                        <ul tabindex="0" class="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-32">
                                            <li><a @click="openPluginSettings(plugin, 'tagSource')">{{ $tt('设置') }}</a></li>
                                            <li><a @click="togglePluginState(plugin, 'tagSource')">{{ getPluginToggleText(plugin) }}</a></li>
                                            <li><a @click="deletePlugin(plugin, 'tagSource')" class="text-error">{{ $tt('删除') }}</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <p class="text-sm text-base-content/70 mt-2 line-clamp-2">{{ plugin.description }}</p>
                                <div class="card-actions justify-end mt-4">
                                    <button class="btn btn-primary btn-sm" @click="configurePlugin(plugin, 'tagSource')">
                                        {{ $tt('配置') }}
                                    </button>
                                    <button v-if="isPluginActive(plugin)" class="btn btn-outline btn-sm" @click="testPlugin(plugin, 'tagSource')" :disabled="testingPluginId === plugin.id">
                                        <span v-if="testingPluginId === plugin.id" class="loading loading-spinner loading-sm"></span>
                                        {{ testingPluginId === plugin.id ? $tt('测试中...') : $tt('测试') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="tagSourceScripts.length === 0" class="text-center py-12">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 mx-auto text-base-content/30" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                        </svg>
                        <h3 class="text-lg font-medium text-base-content/70 mt-4">{{ $tt('暂无标签源插件') }}</h3>
                        <p class="text-base-content/50 mt-2">{{ $tt('点击"添加插件"按钮来添加您的第一个标签源插件') }}</p>
                    </div>
                </div>

                <!-- 操作台插件列表 -->
                <div v-show="activeTab === 'action'" class="p-4 overflow-y-auto flex-1">
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                        <div v-for="(plugin, index) in actionScripts" :key="plugin.id" class="card bg-base-100 shadow-xl hover:shadow-2xl transition-shadow">
                            <div class="card-body p-4">
                                <div class="flex items-start justify-between">
                                    <div class="flex-1">
                                        <h3 class="card-title text-lg">{{ plugin.name }}</h3>
                                        <div class="flex items-center space-x-2 mt-1">
                                            <div class="badge badge-primary badge-sm">v{{ plugin.version }}</div>
                                            <div :class="['badge', 'badge-sm','text-white', getPluginStatusClass(plugin)]">
                                                {{ getPluginStatusText(plugin) }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="dropdown dropdown-end">
                                        <label tabindex="0" class="btn btn-ghost btn-sm btn-circle">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01" />
                                            </svg>
                                        </label>
                                        <ul tabindex="0" class="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-32">
                                            <li><a @click="openPluginSettings(plugin, 'action')">{{ $tt('设置') }}</a></li>
                                            <li><a @click="togglePluginState(plugin, 'action')">{{ getPluginToggleText(plugin) }}</a></li>
                                            <li><a @click="deletePlugin(plugin, 'action')" class="text-error">{{ $tt('删除') }}</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <p class="text-sm text-base-content/70 mt-2 line-clamp-2">{{ plugin.description }}</p>
                                <div class="card-actions justify-end mt-4">
                                    <button class="btn btn-primary btn-sm" @click="configurePlugin(plugin, 'action')">
                                        {{ $tt('配置') }}
                                    </button>
                                    <button v-if="isPluginActive(plugin)" class="btn btn-outline btn-sm" @click="executePlugin(plugin)">>
                                        {{ $tt('执行') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="actionScripts.length === 0" class="text-center py-12">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 mx-auto text-base-content/30" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <h3 class="text-lg font-medium text-base-content/70 mt-4">{{ $tt('暂无操作台插件') }}</h3>
                        <p class="text-base-content/50 mt-2">{{ $tt('点击"添加插件"按钮来添加您的第一个操作台插件') }}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- 上传插件抽屉 -->
        <div class="drawer drawer-end">
            <input id="upload-drawer" type="checkbox" class="drawer-toggle" v-model="showUploadDrawer" />
            <div class="drawer-side">
                <label for="upload-drawer" aria-label="close sidebar" class="drawer-overlay"></label>
                <div class="p-4 min-h-full bg-base-100 text-base-content w-96">
                    <div class="flex justify-between items-center mb-6">
                        <h2 class="text-xl font-bold">{{ $tt('添加插件') }}</h2>
                        <button class="btn btn-sm btn-circle btn-ghost" @click="showUploadDrawer = false">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div class="form-control mb-4">
                        <label class="label">
                            <span class="label-text">{{ $tt('插件类型') }}</span>
                        </label>
                        <select class="select select-bordered" v-model="uploadForm.type">
                            <option value="tagSource">{{ $tt('标签源插件') }}</option>
                            <!-- <option value="action">{{ $tt('操作台插件') }}</option> -->
                        </select>
                    </div>

                    <!-- 示例模板下载 -->
                    <div class="form-control mb-4">
                        <label class="label">
                            <span class="label-text">{{ $tt('下载模板') }}</span>
                        </label>
                        <div class="grid grid-cols-2 gap-2">
                            <button class="btn btn-outline btn-sm" @click="downloadTemplate('tagSource')">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                                {{ $tt('标签源模板') }}
                            </button>
                            <!-- <button class="btn btn-outline btn-sm" @click="downloadTemplate('action', 'py')">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                                操作台模板
                            </button> -->
                        </div>
                        <label class="label">
                            <span class="label-text-alt">{{ $tt('下载对应类型的模板文件，填写后上传') }}</span>
                        </label>
                    </div>

                    <!-- 文件上传区域 -->
                    <div class="form-control mb-6">
                        <label class="label">
                            <span class="label-text">{{ $tt('上传插件文件') }}</span>
                            <span class="label-text-alt">{{ $tt('仅支持 .py 格式') }}</span>
                        </label>
                        
                        <!-- 文件拖拽上传区域 -->
                        <div 
                            class="border-2 border-dashed border-base-300 rounded-lg p-6 text-center transition-colors"
                            :class="{ 'border-primary bg-primary/10': isDragOver }"
                            @dragover.prevent="handleDragOver"
                            @dragleave.prevent="handleDragLeave"
                            @drop.prevent="handleFileDrop"
                        >
                            <input 
                                type="file" 
                                ref="fileInput" 
                                class="hidden" 
                                accept=".py"
                                @change="handleFileSelect"
                            />
                            
                            <div v-if="!uploadedFile">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 mx-auto text-base-content/30 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                </svg>
                                <p class="text-base-content/70 mb-2">{{ $tt('拖拽文件到这里或') }}</p>
                                <button type="button" class="btn btn-outline btn-sm" @click="$refs.fileInput.click()">
                                    {{ $tt('选择文件') }}
                                </button>
                            </div>
                            
                            <!-- 已上传文件信息 -->
                            <div v-else class="text-left">
                                <div class="flex items-center justify-between p-3 bg-base-200 rounded-lg">
                                    <div class="flex items-center space-x-3">
                                        <div class="avatar placeholder">
                                            <div class="bg-base-100 text-primary-content rounded w-10 h-10">
                                                <span class="text-xs">{{ getFileIcon(uploadedFile.name) }}</span>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="font-medium">{{ uploadedFile.name }}</div>
                                            <div class="text-sm text-base-content/70">{{ formatFileSize(uploadedFile.size) }}</div>
                                        </div>
                                    </div>
                                    <div class="flex items-center space-x-2">
                                        <div class="badge badge-success badge-sm">{{ $tt('已选') }}</div>
                                        <button type="button" class="btn btn-ghost btn-xs btn-circle" @click="removeFile">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                
                                <!-- 插件信息显示 -->
                                <div v-if="extractedInfo" class="mt-4 p-3 bg-base-200 rounded-lg">
                                    <h4 class="font-semibold mb-2">{{ $tt('识别的插件信息') }}</h4>
                                    <div class="space-y-1 text-sm">
                                        <div v-if="extractedInfo.name"><span class="font-medium">{{ $tt('名称:') }}</span> {{ extractedInfo.name }}</div>
                                        <div v-if="extractedInfo.version"><span class="font-medium">{{ $tt('版本:') }}</span> {{ extractedInfo.version }}</div>
                                        <div v-if="extractedInfo.description"><span class="font-medium">{{ $tt('描述:') }}</span> {{ extractedInfo.description }}</div>
                                        <div v-if="extractedInfo.author"><span class="font-medium">{{ $tt('作者:') }}</span> {{ extractedInfo.author }}</div>
                                        <div v-if="extractedInfo.unique_id"><span class="font-medium">ID:</span> {{ extractedInfo.unique_id }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- 文件验证错误信息 -->
                        <div v-if="fileError" class="alert alert-error mt-2">
                            <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span>{{ fileError }}</span>
                        </div>
                    </div>

                    <div class="flex justify-end space-x-2">
                        <button class="btn btn-outline btn-sm" @click="resetUploadForm">{{ $tt('重置') }}</button>
                        <button class="btn btn-primary btn-sm" @click="uploadPlugin" :disabled="!canUpload">
                            <span class="loading loading-spinner loading-sm" v-if="uploading"></span>
                            {{ uploading ? $tt('上传中...') : $tt('上传插件') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 插件配置抽屉 -->
        <PluginConfigDrawer 
            :plugin="currentPlugin"
            :plugin-type="currentPluginType"
            :show="showConfigDrawer"
            @update:show="showConfigDrawer = $event"
            @config-updated="handleConfigUpdated"
        />

        <!-- 删除确认模态框 -->
        <dialog id="delete_plugin_modal" class="modal">
            <div class="modal-box">
                <h3 class="font-bold text-lg">{{ $tt('删除插件') }}</h3>
                <p class="py-4">
                    {{ $tt('plugin.delete.confirm', { name: pluginToDelete?.display_name || pluginToDelete?.name }) }}
                </p>
                <p class="text-sm text-base-content/70">
                    {{ $tt('删除后将无法恢复，请谨慎操作！') }}
                </p>
                <div class="modal-action">
                    <button class="btn btn-outline btn-sm" @click="cancelDeletePlugin">{{ $tt('取消') }}</button>
                    <button class="btn btn-error btn-sm" @click="confirmDeletePlugin">{{ $tt('删除') }}</button>
                </div>
            </div>
        </dialog>
    </div>
</template>

<script>
import PluginConfigDrawer from '@/components/mod/PluginConfigDrawer.vue'
export default {
    name: 'PluginManager',
    components: {
        PluginConfigDrawer,
    },
    data() {
        return {
            activeTab: 'tagSource',
            tagSourceScripts: [],
            actionScripts: [],
            showUploadDrawer: false,
            showConfigDrawer: false,
            uploading: false,
            testingPluginId: null, // 正在测试的插件ID
            currentPlugin: null,
            currentPluginType: null,
            uploadForm: {
                type: 'tagSource',
                content: '',
                file: null
            },
            uploadedFile: null,
            isDragOver: false,
            fileError: null,
            extractedInfo: null,
            pluginToDelete: null,
            pluginTypeToDelete: null
        }
    },
    computed: {
        canUpload() {
            return this.uploadedFile && this.extractedInfo && !this.uploading && !this.fileError
        },
    },
    created() {
        this.fetchPlugins()
    },
    methods: {
        async fetchPlugins() {
            try {
                // 获取标签源插件
                const tagResponse = await this.$api.Task.getResourceScript({ page_size: 100, plugin_type: 'tag_source' })
                if (tagResponse.result) {
                    this.tagSourceScripts = tagResponse.data.items || []
                }

                // 获取操作台插件
                const actionResponse = await this.$api.Task.getActionScript({ page_size: 100 })
                if (actionResponse.result) {
                    this.actionScripts = actionResponse.data.items || []
                }
            } catch (error) {
                this.$myMsg.notify({
                    title: this.$tt('获取插件列表失败'),
                    content: error.message,
                    type: 'error',
                    time: 3000
                })
            }
        },
        
        async refreshPlugins() {
            try {
                // 首先调用插件系统重新加载接口
                this.$myMsg.notify({
                    title: this.$tt('正在重新加载插件系统...'),
                    type: 'info',
                    time: 2000
                })
                
                const reloadResponse = await this.$api.scriptMgmt.reloadPlugins()
                
                if (reloadResponse.result) {
                    const loadStats = reloadResponse.data.load_stats
                    
                    // 显示重新加载结果
                    this.$myMsg.notify({
                        title: this.$tt('插件系统重新加载完成'),
                        content: this.$tt('plugin.reload.summary', { total: loadStats.total_discovered, success: loadStats.loaded_success }),
                        type: 'success',
                        time: 3000
                    })
                    
                    // 如果有加载失败的插件，显示警告
                    if (loadStats.loaded_failed > 0) {
                        this.$myMsg.notify({
                            title: this.$tt('部分插件加载失败'),
                            content: this.$tt('plugin.reload.failedCount', { failed: loadStats.loaded_failed }),
                            type: 'warning',
                            time: 4000
                        })
                    }
                } else {
                    throw new Error(reloadResponse.message || this.$tt('插件系统重新加载失败'))
                }
                
                // 然后刷新插件列表
                await this.fetchPlugins()
                
            } catch (error) {
                console.error('重新加载插件系统失败:', error)
                this.$myMsg.notify({
                    title: this.$tt('重新加载失败'),
                    content: error.message || this.$tt('插件系统重新加载失败，将尝试普通刷新'),
                    type: 'error',
                    time: 3000
                })
                
                // 如果重新加载失败，降级为普通刷新
                try {
                    await this.fetchPlugins()
                    this.$myMsg.notify({
                        title: this.$tt('列表刷新成功'),
                        type: 'success',
                        time: 2000
                    })
                } catch (fetchError) {
                    this.$myMsg.notify({
                        title: this.$tt('刷新失败'),
                        content: fetchError.message,
                        type: 'error',
                        time: 3000
                    })
                }
            }
        },

        configurePlugin(plugin, type) {
            this.currentPlugin = plugin
            this.currentPluginType = type
            this.showConfigDrawer = true
        },

        openPluginSettings(plugin, type) {
            this.configurePlugin(plugin, type)
        },

        async handleConfigUpdated(data) {
            // 处理插件配置更新
            const { plugin, config, enabled } = data
            
            try {
                // 调用API更新插件配置
                const response = await this.$api.scriptMgmt.updatePluginConfig(plugin.id, {
                    config_data: config
                })

                if (response.result) {
                    // 更新插件状态
                    plugin.state = enabled ? 'online' : 'offline'
                    plugin.config = config
                    
                    this.$myMsg.notify({
                        title: this.$tt('插件配置保存成功'),
                        type: 'success',
                        time: 2000
                    })
                    
                    this.fetchPlugins()
                } else {
                    throw new Error(response.message || this.$tt('保存配置失败'))
                }
            } catch (error) {
                this.$myMsg.notify({
                    title: this.$tt('保存配置失败'),
                    content: error.message,
                    type: 'error',
                    time: 3000
                })
                console.error('保存插件配置失败:', error)
            }
        },

        async togglePluginState(plugin, type) {
            try {
                let response
                const currentStatus = plugin.status || plugin.state
                
                if (currentStatus === 'active' || currentStatus === 'online') {
                    // 停用插件
                    response = await this.$api.scriptMgmt.deactivatePlugin(plugin.id)
                    if (response.result) {
                        plugin.status = 'inactive'
                        plugin.state = 'offline'
                        this.$myMsg.notify({
                            title: this.$tt('插件停用成功'),
                            type: 'success',
                            time: 2000
                        })
                    }
                } else {
                    // 激活插件
                    response = await this.$api.scriptMgmt.activatePlugin(plugin.id)
                    if (response.result) {
                        plugin.status = 'active'
                        plugin.state = 'online'
                        this.$myMsg.notify({
                            title: this.$tt('插件激活成功'),
                            type: 'success',
                            time: 2000
                        })
                    }
                }
                
                if (!response.result) {
                    throw new Error(response.message || this.$tt('操作失败'))
                }
                
            } catch (error) {
                this.$myMsg.notify({
                    title: this.$tt('操作失败'),
                    content: error.message,
                    type: 'error',
                    time: 3000
                })
            }
        },

        async deletePlugin(plugin, type) {
            this.pluginToDelete = plugin
            this.pluginTypeToDelete = type
            document.getElementById('delete_plugin_modal').showModal()
        },

        cancelDeletePlugin() {
            this.pluginToDelete = null
            this.pluginTypeToDelete = null
            document.getElementById('delete_plugin_modal').close()
        },

        async confirmDeletePlugin() {
            if (!this.pluginToDelete || !this.pluginTypeToDelete) return

            try {
                const response = await this.$api.scriptMgmt.disablePlugin(this.pluginToDelete.id)
                
                if (response.result) {
                    // 从列表中移除插件
                    if (this.pluginTypeToDelete === 'tagSource') {
                        this.tagSourceScripts = this.tagSourceScripts.filter(p => p.id !== this.pluginToDelete.id)
                    } else {
                        this.actionScripts = this.actionScripts.filter(p => p.id !== this.pluginToDelete.id)
                    }
                    
                    this.$myMsg.notify({
                        title: this.$tt('插件删除成功'),
                        type: 'success',
                        time: 2000
                    })
                } else {
                    throw new Error(response.message || this.$tt('删除失败'))
                }
            } catch (error) {
                this.$myMsg.notify({
                    title: this.$tt('删除失败'),
                    content: error.message,
                    type: 'error',
                    time: 3000
                })
            } finally {
                this.pluginToDelete = null
                this.pluginTypeToDelete = null
                document.getElementById('delete_plugin_modal').close()
            }
        },

        async testPlugin(plugin, type) {
            // 防止重复测试
            if (this.testingPluginId === plugin.id) {
                return
            }

            try {
                this.testingPluginId = plugin.id

                this.$myMsg.notify({
                    title: this.$tt('测试插件中...'),
                    type: 'info',
                    time: 2000
                })

                const response = await this.$api.Task.testExecutePlugin({
                    id: plugin.id,
                    test_mode: 'sample'
                })

                if (response.result) {
                    const result = response.data
                    const testStatus = result.execution_result.success ? this.$tt('成功') : this.$tt('失败')
                    this.$myMsg.notify({
                        title: this.$tt('插件测试完成'),
                        content: this.$tt('执行结果: {status} - {message}', { status: testStatus, message: result.execution_result.message }),
                        type: result.execution_result.success ? 'success' : 'warning',
                        time: 4000
                    })
                } else {
                    throw new Error(response.message || this.$tt('测试失败'))
                }
            } catch (error) {
                this.$myMsg.notify({
                    title: this.$tt('测试失败'),
                    content: error.message || error,
                    type: 'error',
                    time: 3000
                })
            } finally {
                this.testingPluginId = null
            }
        },

        async executePlugin(plugin) {
            try {
                this.$myMsg.notify({
                    title: this.$tt('执行插件中...'),
                    type: 'info',
                    time: 2000
                })
                // 这里应该调用执行插件的API
                // 对于操作台插件，跳转到具体的操作页面
                this.$router.push({ name: 'actionMod', params: { id: plugin.id } })
            } catch (error) {
                this.$myMsg.notify({
                    title: this.$tt('执行失败'),
                    content: error.message,
                    type: 'error',
                    time: 3000
                })
            }
        },

        async uploadPlugin() {
            if (!this.canUpload) return

            this.uploading = true
            try {
                // 创建 FormData 对象
                const formData = new FormData()
                formData.append('plugin_file', this.uploadedFile)
                formData.append('plugin_type', this.uploadForm.type === 'tagSource' ? 'tag_source' : 'batch_action')
                
                // 调用上传 API
                const response = await this.$api.scriptMgmt.uploadPlugin(formData)
                
                if (response.result) {
                    this.$myMsg.notify({
                        title: this.$tt('插件上传成功'),
                        content: this.$tt('插件 "{name}" 已成功上传', { name: this.extractedInfo.name }),
                        type: 'success',
                        time: 2000
                    })
                    
                    this.resetUploadForm()
                    this.showUploadDrawer = false
                    this.fetchPlugins()
                } else {
                    throw new Error(response.message || this.$tt('上传失败'))
                }
            } catch (error) {
                this.$myMsg.notify({
                    title: this.$tt('上传失败'),
                    content: error.message,
                    type: 'error',
                    time: 3000
                })
            } finally {
                this.uploading = false
            }
        },

        resetUploadForm() {
            this.uploadForm = {
                type: 'tagSource',
                content: '',
                file: null
            }
            this.uploadedFile = null
            this.fileError = null
            this.extractedInfo = null
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = ''
            }
        },

        handleDragOver(event) {
            event.preventDefault()
            this.isDragOver = true
        },

        handleDragLeave(event) {
            event.preventDefault()
            this.isDragOver = false
        },

        handleFileDrop(event) {
            event.preventDefault()
            this.isDragOver = false
            const files = event.dataTransfer.files
            if (files.length > 0) {
                this.processFile(files[0])
            }
        },

        handleFileSelect(event) {
            const files = event.target.files
            if (files.length > 0) {
                this.processFile(files[0])
            }
        },

        async processFile(file) {
            this.fileError = null
            this.extractedInfo = null
            
            // 文件类型验证
            const fileExtension = file.name.split('.').pop().toLowerCase()
            
            if (fileExtension !== 'py') {
                this.fileError = this.$tt('仅支持 .py 文件，当前文件类型：.{ext}', { ext: fileExtension })
                return
            }

            // 文件大小验证（限制为2MB）
            const maxSize = 2 * 1024 * 1024 // 2MB
            if (file.size > maxSize) {
                this.fileError = this.$tt('文件过大：{size}。最大允许：{maxSize}', { size: this.formatFileSize(file.size), maxSize: this.formatFileSize(maxSize) })
                return
            }

            this.uploadedFile = file
            this.uploadForm.file = file

            try {
                // 读取文件内容
                const content = await this.readFileContent(file)
                this.uploadForm.content = content

                // 从文件内容中提取插件信息
                this.extractedInfo = this.extractPluginInfo(content, file.name)

                if (!this.extractedInfo.name || !this.extractedInfo.unique_id) {
                    this.fileError = this.$tt('无法从文件中识别插件信息，请确保文件包含必要的元数据注释')
                    this.uploadedFile = null
                    this.uploadForm.file = null
                    return
                }

                this.$myMsg.notify({
                    title: this.$tt('文件读取成功'),
                    content: this.$tt('已识别插件: {name}', { name: this.extractedInfo.name }),
                    type: 'success',
                    time: 2000
                })

            } catch (error) {
                this.fileError = this.$tt('读取文件失败：{message}', { message: error.message })
                this.uploadedFile = null
                this.uploadForm.file = null
            }
        },

        readFileContent(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                
                reader.onload = (event) => {
                    try {
                        const content = event.target.result
                        // 验证文件内容是否为文本
                        if (typeof content === 'string') {
                            resolve(content)
                        } else {
                            reject(new Error(this.$tt('文件不是有效的文本格式')))
                        }
                    } catch (error) {
                        reject(error)
                    }
                }
                
                reader.onerror = () => {
                    reject(new Error(this.$tt('文件读取失败')))
                }
                
                reader.readAsText(file, 'UTF-8')
            })
        },

        extractPluginInfo(content, fileName) {
            const info = {
                name: null,
                unique_id: null,
                version: '1.0.0',
                description: null,
                author: null,
                type: null
            }

            // 从文件名提取默认标识
            const baseName = fileName.replace('.py', '')
            info.unique_id = baseName.toLowerCase().replace(/[^a-z0-9_]/g, '_')

            // 尝试从代码注释中提取插件信息
            const lines = content.split('\n')
            
            for (let i = 0; i < Math.min(lines.length, 50); i++) { // 检查前50行
                const line = lines[i].trim()
                
                // Python风格注释
                if (line.startsWith('#') || line.startsWith('"""') || line.startsWith("'''")) {
                    this.parseMetadataLine(line, info)
                }
                
                // 检查多行文档字符串
                if (line.startsWith('"""') || line.startsWith("'''")) {
                    const endQuote = line.startsWith('"""') ? '"""' : "'''"
                    let j = i + 1
                    while (j < lines.length && !lines[j].includes(endQuote)) {
                        this.parseMetadataLine(lines[j], info)
                        j++
                    }
                }
                
                // 检查类定义
                if (line.match(/^class\s+(\w+).*Plugin/)) {
                    const match = line.match(/^class\s+(\w+)/)
                    if (match && !info.name) {
                        info.name = match[1].replace(/([A-Z])/g, ' $1').trim()
                    }
                }
            }

            // 如果没有提取到名称，使用文件名
            if (!info.name) {
                info.name = baseName.replace(/[_-]/g, ' ')
            }

            // 根据选择的类型设置
            if (!info.type) {
                info.type = this.uploadForm.type
            }

            return info
        },

        parseMetadataLine(line, info) {
            // 移除注释符号
            const cleanLine = line.replace(/^[#"'\s]+/, '').replace(/["'\s]+$/, '').trim()
            
            // 解析常见的元数据格式
            const patterns = [
                { regex: /^[Nn]ame:\s*(.+)/i, field: 'name' },
                { regex: /^[Vv]ersion:\s*(.+)/i, field: 'version' },
                { regex: /^[Dd]escription:\s*(.+)/i, field: 'description' },
                { regex: /^[Aa]uthor:\s*(.+)/i, field: 'author' },
                { regex: /^ID:\s*(.+)/i, field: 'unique_id' },
                { regex: /^[Uu]nique_?[Ii]d:\s*(.+)/i, field: 'unique_id' },
                { regex: /^[Tt]ype:\s*(.+)/i, field: 'type' }
            ]
            
            for (const pattern of patterns) {
                const match = cleanLine.match(pattern.regex)
                if (match && !info[pattern.field]) {
                    info[pattern.field] = match[1].trim()
                }
            }
        },

        removeFile() {
            this.uploadedFile = null
            this.uploadForm.content = ''
            this.uploadForm.file = null
            this.fileError = null
            this.extractedInfo = null
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = ''
            }
        },

        getFileIcon(fileName) {
            const extension = fileName.split('.').pop().toLowerCase()
            switch (extension) {
                case 'py':
                    return '🐍'
                default:
                    return '📄'
            }
        },

        formatFileSize(size) {
            if (size < 1024) {
                return size + ' B'
            } else if (size < 1024 * 1024) {
                return (size / 1024).toFixed(2) + ' KB'
            } else if (size < 1024 * 1024 * 1024) {
                return (size / (1024 * 1024)).toFixed(2) + ' MB'
            } else {
                return (size / (1024 * 1024 * 1024)).toFixed(2) + ' GB'
            }
        },

        async downloadTemplate(type) {
            try {
                // 调用后端API获取模板内容
                const templateType = type === 'tagSource' ? 'tag_source' : 'batch_action'
                
                this.$myMsg.notify({
                    title: this.$tt('正在下载模板...'),
                    type: 'info',
                    time: 2000
                })
                
                // 使用axios发送请求，这样会携带认证信息
                const response = await this.$api.scriptMgmt.downloadTemplate(templateType)
                
                if (response.result && response.data) {
                    const { filename, content } = response.data
                    
                    // 创建Blob并触发下载
                    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' })
                    const url = window.URL.createObjectURL(blob)
                    
                    // 创建隐藏的链接元素并触发下载
                    const a = document.createElement('a')
                    a.href = url
                    a.download = filename
                    a.style.display = 'none'
                    document.body.appendChild(a)
                    a.click()
                    document.body.removeChild(a)
                    
                    // 释放URL对象
                    window.URL.revokeObjectURL(url)
                    
                    this.$myMsg.notify({
                        title: this.$tt('模板下载成功'),
                        content: this.$tt('plugin.template.downloaded', { type: type === 'tagSource' ? this.$tt('标签源') : this.$tt('批量操作') }),
                        type: 'success',
                        time: 2000
                    })
                } else {
                    throw new Error(response.message || this.$tt('下载失败'))
                }
            } catch (error) {
                console.error('下载模板失败:', error)
                this.$myMsg.notify({
                    title: this.$tt('下载失败'),
                    content: error.message || this.$tt('模板下载失败'),
                    type: 'error',
                    time: 3000
                })
            }
        },

        // 新增辅助方法
        getPluginStatusClass(plugin) {
            const status = plugin.status || plugin.state
            if (status === 'active' || status === 'online') {
                return 'badge-success'
            } else if (status === 'inactive' || status === 'offline') {
                return 'badge-warning'
            } else {
                return 'badge-error'
            }
        },

        getPluginStatusText(plugin) {
            const status = plugin.status || plugin.state
            if (status === 'active' || status === 'online') {
                return this.$tt('在线')
            } else if (status === 'inactive' || status === 'offline') {
                return this.$tt('离线')
            } else {
                return this.$tt('禁用')
            }
        },

        getPluginToggleText(plugin) {
            const status = plugin.status || plugin.state
            if (status === 'active' || status === 'online') {
                return this.$tt('停用')
            } else {
                return this.$tt('激活')
            }
        },

        isPluginActive(plugin) {
            const status = plugin.status || plugin.state
            return status === 'active' || status === 'online'
        }
    }
}
</script>

<style scoped>
.line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.h-screen-header {
    height: calc(100vh - 4rem);
}
</style>
